import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getHeaders } from "../../../utils/requestHeaders";
import { API_HOST } from "../../../utils/constants";
import { buildMutationHelper } from "../../../utils/buildMutationHelper";
import { setTimeAndAttendanceReject } from "../../reducer/time-and-attendance/time-and-attendanceReject";
import { defaultFromState } from "../../../utils/defaultFromState";

export const timeAndAttendanceRejectApi = createApi({
  reducerPath: "timeAndAttendanceRejectApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_HOST,
  }),
  endpoints: (builder) => ({
    getRejectData: buildMutationHelper(
      builder,
      ({
        page = undefined,
        itemsPerPage = undefined,
        projectId = undefined,
        pagination = undefined,
        sortBy = undefined,
        sortType = undefined,
        checkInDate = undefined,
        checkOutDate = undefined,
        client = localStorage?.selectedClientId ?? undefined,
      } = {}) => {
        return {
          url: "/tna/rejected-project-tna",
          params: {
            page: page,
            itemsPerPage: itemsPerPage,
            pagination: pagination,
            projectId,
            sortBy,
            sortType,
            checkInDate: checkInDate,
            checkOutDate: checkOutDate,
            client,
          },
          method: "GET",
          headers: getHeaders(),
          defaultFromState: (getState, args) => {
            const {
              timeAndAttendanceReject: {
                page,
                itemsPerPage,
                pagination,
                projectId,
                sortBy,
                sortType,
                checkInDate,
                checkOutDate,
                client,
              },
            } = getState();
            let stateParams = {
              page,
              itemsPerPage,
              pagination,
              projectId,
              sortBy,
              sortType,
              checkInDate,
              checkOutDate,
              client,
            };

            return defaultFromState(stateParams, args);
          },
        };
      },
      (response, dispatch) => {
        if (
          new URL(response?.meta?.request?.url).searchParams.get(
            "pagination"
          ) === null
        ) {
          const { data } = response?.data;
          const totalCount = response?.data?.totalItems;
          dispatch(
            setTimeAndAttendanceReject({
              data,
              totalCount,
              errorMessage: "",
            })
          );
        } else {
          const exportData = response?.data;
          dispatch(
            setTimeAndAttendanceReject({
              exportData,
              errorMessage: "",
            })
          );
        }
      },
      ({ error }, dispatch) => {
        dispatch(
          setTimeAndAttendanceReject({ errorMessage: error?.data?.error })
        );
      }
    ),
  }),
});

export const { useGetRejectDataMutation } = timeAndAttendanceRejectApi;
